// extracted by mini-css-extract-plugin
export default {"instructions":"future_R2t3OJQDGYoI","box":"future_Y3c8dnULUscE","center":"future_O5u1sNBMHAgN"};